import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { Button } from '../ui/Button';
export function Problema() {
  const cards = [{
    icon: '🌙',
    title: '"No podía dormir porque se me subía el ácido"',
    desc: 'Son las 3 de la mañana. El ardor en el pecho no cede. Sentís la lumbre subiendo por la garganta. Buscás agua, te sentás derecho, pero el fuego sigue. Tu descanso desapareció hace meses.'
  }, {
    icon: '🍽️',
    title: '"Todo lo que comía me ponía mal, hasta el agua"',
    desc: 'Dolor en el estómago, gases, flema, tos crónica, atoro en la garganta. Ya no sabés qué podés comer. Todo te da ardor. Es agobiante.'
  }, {
    icon: '💊',
    title: '"Lo único que me funciona es el omeprazol"',
    desc: 'Omeprazol, esomeprazol, dexlansoprazol... Apagan el ácido pero no arreglan la válvula que falla. Cuando parás, el ardor vuelve más fuerte. Estás atrapado en un ciclo de dependencia.'
  }];
  return <section id="problema" className="py-[100px] bg-gradient-to-b from-[#1a0f08] to-[#201408]" data-id="element-293">
      <div className="container-custom" data-id="element-294">
        <SectionHeader eyebrow="El problema real" title={<>
              No es "mucho ácido".
              <br data-id="element-296" />
              <span className="text-gold" data-id="element-297">Es la válvula que falla.</span>
            </>} description="Probaste vinagre de manzana, bicarbonato, sábila, jengibre, cúrcuma... y seguís igual. Te dijeron que tenés demasiado ácido. Pero el verdadero problema es la válvula Cardias: está perezosa y deja que el ácido suba a tu garganta." data-id="element-295" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-gold/10 border border-gold/10 rounded-[12px] overflow-hidden mb-[60px]" data-id="element-298">
          {cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-[#1e0e08] p-[36px_28px] transition-colors duration-300 hover:bg-[#281408]" data-id="element-299">
              <span className="text-[28px] mb-3.5 block" data-id="element-300">{card.icon}</span>
              <h3 className="font-display text-[18px] font-bold text-white mb-2.5" data-id="element-301">
                {card.title}
              </h3>
              <p className="text-[14px] text-gray leading-[1.6]" data-id="element-302">{card.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-[680px] mx-auto text-center p-10 border-y border-gold/15" data-id="element-303">
          <blockquote className="font-display text-[clamp(18px,2.5vw,24px)] italic text-white/90 leading-[1.5] mb-4" data-id="element-304">
            "Mientras sigas apagando el ácido con pastillas, la válvula nunca va
            a aprender a cerrarse sola."
          </blockquote>
          <cite className="text-[13px] text-gray not-italic" data-id="element-305">
            — Hugo Pagano, Protocolo de Reprogramación Digestiva™
          </cite>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 text-center" data-id="element-306">
          <p className="text-[15px] text-gray mb-4" data-id="element-307">
            Descubrí cómo cerrar la válvula que realmente falla →
          </p>
          <Button href="#oferta" variant="secondary" fullWidth={false} data-id="element-308">
            Ver el Protocolo Completo
          </Button>
        </motion.div>
      </div>
    </section>;
}